import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="relative w-12 h-12 flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg transform rotate-45"></div>
              <div className="relative z-10 text-white font-bold text-xl">
                <span className="text-2xl">Z</span>
                <span className="text-lg">I</span>
              </div>
            </div>
            <div className="ml-3">
              <h1 className="text-xl font-bold text-blue-900">ZHONGMING IMPORT</h1>
              <p className="text-sm text-gray-600 font-medium" style={{ letterSpacing: '0.1em' }}>Soluciones Profesionales B2B</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Inicio
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Servicios
            </button>
            <button onClick={() => scrollToSection('catalog')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Catálogo
            </button>
            <button onClick={() => scrollToSection('projects')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Proyectos
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-blue-900 text-white px-6 py-2.5 rounded-lg hover:bg-blue-800 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Contacto Profesional
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors text-left whitespace-nowrap cursor-pointer">
                Inicio
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors text-left whitespace-nowrap cursor-pointer">
                Servicios
              </button>
              <button onClick={() => scrollToSection('catalog')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors text-left whitespace-nowrap cursor-pointer">
                Catálogo
              </button>
              <button onClick={() => scrollToSection('projects')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors text-left whitespace-nowrap cursor-pointer">
                Proyectos
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-blue-900 text-white px-6 py-2.5 rounded-lg hover:bg-blue-800 transition-colors font-medium text-left whitespace-nowrap cursor-pointer">
                Contacto Profesional
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
